import script from "./NewEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./NewEvent.vue?vue&type=script&setup=true&lang=js"

import "./NewEvent.vue?vue&type=style&index=0&id=43c1cfb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c1cfb4"]])

export default __exports__